module.exports = __webpack_public_path__ + "static/media/2.3cf1a4f5.svg";